export default "__VITE_ASSET__299baa35__"